/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 * SCS.utils
	 *
	 */

	'use strict';
	/*globals Tc */

	/**
	 * SmoToken Implementation
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class SmoToken
	 * @extends Tc.Module
	 */
	Tc.Module.SmoToken = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			this.originalSubmitButton = this.$ctx.find('.button-indent');
			this.secondSubmitButton = this.originalSubmitButton.clone();
			this.phoneField = this.$ctx.find('input[type=tel]');
			this.emailField = this.$ctx.find('input[type=email]');
			this.phoneParentField = this.phoneField.closest('.field');
			this.emailParentField = this.emailField.closest('.field');
			this.smotokenform = this.$ctx.find('form');

			this.phoneParentField.closest('.textfield.section').append(this.originalSubmitButton);
			this.emailParentField.closest('.textfield.section').append(this.secondSubmitButton);

			this.originalSubmitButton.on('click', $.proxy(this.handleSubmitButtonClick, this));
			this.secondSubmitButton.on('click', $.proxy(this.handleSubmitButtonClick, this));

			this.phoneField.on('keypress', $.proxy(this.handleKeyPressPhone, this));
			this.emailField.on('keypress', $.proxy(this.handleKeyPressEmail, this));

			callback();
		},

		handleSubmitButtonClick: function (event){
			if($(event.currentTarget).is(this.originalSubmitButton)) {
				this.handleInputFieldFocusInPhone();
			}
			else {
				this.handleInputFieldFocusInEmail();
			}
		},

		handleInputFieldFocusInPhone: function (){
			this.emailField.val('');
			this.setRequiredOfField(this.phoneParentField, true);
			this.setRequiredOfField(this.emailParentField, false);
		},

		handleInputFieldFocusInEmail: function (){
			this.phoneField.val('');
			this.setRequiredOfField(this.emailParentField, true);
			this.setRequiredOfField(this.phoneParentField, false);
		},

		handleKeyPressPhone: function (event){
			if(event.which == 13) {
				event.preventDefault();
				this.handleInputFieldFocusInPhone();
				this.smotokenform.trigger('submit');
			}
		},

		handleKeyPressEmail: function (event){
			if(event.which == 13) {
				event.preventDefault();
				this.handleInputFieldFocusInEmail();
				this.smotokenform.trigger('submit');
			}
		},

		setRequiredOfField: function(field, value) {
			var clientValidation = field.data('clientvalidation');
			if (clientValidation) {
				clientValidation.required = value;
				field.data('clientvalidation', clientValidation);
				field.attr('data-clientvalidation', clientValidation);
			}
		}
	});

}(Tc.$, window.SCS = window.SCS || {}));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.SmoToken.js
// module id = 182
// module chunks = 0